import CaspianXxApiClientAndSurveyIdPairItem from "../Domain/CaspianXxApiClientAndSurveyIdPairItem.js";
import dateTimeHelper from "../Helpers/datetimeHelper.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import CaspianXXApiClientAndSurveyIdPairSearchParams from "../Contents/RoverImport/CaspianXXApiClientAndSurveyIdPairAdmin/CaspianXXApiClientAndSurveyIdPairSearchParams";

export default class CaspianXXApiClientAndSurveyIdPairService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CaspianXXApiClientAndSurveyIdPairSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/CaspianXExtraApiClientAndSurveyIdPair/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new CaspianXxApiClientAndSurveyIdPairItem(item));
    }

    return mappedItems;
  }

  static Edit(queryItem) {
    queryItem = serviceHelper.ConvertAllPropertyToString(queryItem);
    queryItem.StartDate = dateTimeHelper.toYYYYsMMsDD(queryItem.StartDate);
    queryItem.EndDate = dateTimeHelper.toYYYYsMMsDD(queryItem.EndDate);
    let queryItemJSON = JSON.stringify(queryItem);

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/CaspianXExtraApiClientAndSurveyIdPair/Edit',
      queryItemJSON
    );
  }

  static MassEdit(editCriteria) {
    editCriteria.EndDate = dateTimeHelper.toYYYYsMMsDD(editCriteria.EndDate);
    editCriteria.SearchParams = {
      Command: '',
      OrderBy: '',
      OrderDirection: '',
      PageNumber: 0,
      NumberOfElementsOnAPage: 0,
      SearchItem: editCriteria.SearchParams,
    };

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/CaspianXExtraApiClientAndSurveyIdPair/MassEdit',
      JSON.stringify(editCriteria)
    );
  }
}
